<template>
    <blank-layout>
        <v-row no-gutters>
            <v-col cols="12" lg="7" xl="6" class="info d-none d-md-flex align-center justify-center">
                <v-container>
                    <div class="pa-10">
                        <v-row justify="center">
                            <v-col cols="8" xl="5">
                            <div>
                                <div class="text-center">
                                    <v-avatar color="white" width="200" height="200">
                                        <img src="images/logo.png">
                                    </v-avatar>
                                </div>
                                <br>
                                <h2 class="text-center display-2 white--text font-weight-medium">
                                    JMD OMS
                                </h2>
                                <h3 class="text-center white--text font-normal">
                                    Order Management System
                                </h3>
                            </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </v-col>
            <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
            <v-container>
            <div class="pa-7 pa-sm-12">
               <v-row>
                  <v-col cols="12" lg="9" xl="6">
                  <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">Sign-In</h2>
                  <h6 class="subtitle-1">
                     <small>If using QID, it must be the QID number assigned by JMD for your account.</small>
                  </h6>

                  <v-form ref="form" v-model="valid" lazy-validation>
                     <v-text-field v-model="identity" label="Email / QID No." class="mt-4" outlined></v-text-field>
                     <v-text-field v-model="password" :counter="15" :rules="passwordRules" label="Password" required outlined :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                     <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                        <v-checkbox v-model="rememberme" label="Remember me?" required></v-checkbox>
                        <div class="ml-auto">
                           <a href="/forgot-password" class="link">Forgot Password?</a>
                        </div>
                     </div>
                     <v-btn :disabled="!valid||submitting" color="info" block class="mr-4" submit @click="submit">
                        Login
                     </v-btn>
                  </v-form>
                  <v-snackbar v-model="showerror" timeout="10000" color="red" dark centered>
                     {{ errormsg }}
                     <template v-slot:action="{ attrs }">
                     <v-btn color="white" text v-bind="attrs" @click="showerror = false">
                        Close
                     </v-btn>
                     </template>
                  </v-snackbar>
                  </v-col>
               </v-row>
            </div>
            </v-container>
         </v-col>
        </v-row>
    </blank-layout>
</template>

<script>
import BlankLayout from '../Layouts/BlankLayout.vue'
export default {
    name: 'UserLogin',
    props: {

    },
    components: {
        BlankLayout
    },
    data() {
        return {
            showerror: false,
            errormsg: '',
            submitting: false,
            valid: true,
            password: "",
            show1: false,
            passwordRules: [
                v => !!v || "Password is required",
                v => (v && v.length >= 9) || "Password must be more than 8 characters"
            ],
            email: '',
            emailRules: [
                v => ((v !== '') ? /.+@.+\..+/.test(v) : true) || 'Must be a valid email'
            ],
            icno: '',
            identity: '',
            rememberme: false
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {
        submit() {
            this.$refs.form.validate()

            var data = {
                email: this.identity,
                password: this.password,
                remember: this.rememberme
            }

            if (this.$refs.form.validate(true)) {
                this.$inertia.post(this.route('login'), data, {
                    onStart: () => this.submitting = true,
                    onFinish: () => {
                        this.submitting = false
                        if (this.$page.props.errors) {
                            if (Object.keys(this.$page.props.errors).length > 0) {
                                this.errormsg = ''
                                for (const itm in this.$page.props.errors) {
                                    this.errormsg += `${itm}: ${this.$page.props.errors[itm]}`
                            }
                            this.showerror = true
                        }
                    }
                }
                })
            }
        }
    }
}
// -----------------------
// EXPORT DEFAULT TEMPLATE
// -----------------------
// export default {
//     name: 'MemberLogin',
//     props: {

//     },
//     components: {
//         BlankLayout

//     },
//     data() {
//         return {

//         }
//     },
//     watch: {},
//     computed: {},
//     mounted: function () {},
//     methods: {

//     }
// }
</script>
